import { CommonModule } from '@angular/common';
import { Component } from '@angular/core';
import {
  FormlyFieldProps as CoreFormlyFieldProps,
  FieldWrapper,
  FormlyFieldConfig,
} from '@ngx-formly/core';

import { IconFieldModule } from 'primeng/iconfield';
import { InputGroup } from 'primeng/inputgroup';
import { InputGroupAddon } from 'primeng/inputgroupaddon';
import { InputIconModule } from 'primeng/inputicon';
import { FORM_IMPORTS } from '../../_shared/_imports/form.import';

export interface FormlyFieldProps extends CoreFormlyFieldProps {
  hideRequiredMarker?: boolean;
  hideLabel?: boolean;
  addonLeft?: any;
  addonRight?: any;
  labelKey?: string;
  warning?: string;
  icon?: string;
  iconPosition?: 'left' | 'right';
}

@Component({
  selector: 'formly-wrapper-primeng-form-field',
  standalone: true,
  imports: [
    CommonModule,
    InputGroup,
    InputGroupAddon,
    ...FORM_IMPORTS,
    IconFieldModule,
    InputIconModule,
  ],
  template: `
    <div class="p-field">
      @if (props.label && props.hideLabel !== true) {
        <label
          class="ml-[var(--p-inputtext-padding-x)]"
          [for]="id"
          [innerHTML]="props.label"
        >
        </label>
      }
      @if (props.addonLeft || props.addonRight) {
        <p-inputGroup
          class="{{ formControl.valid ? '' : 'ng-invalid' }} {{
            props.addonLeft ? 'addon-prefix' : ''
          }} {{ props.addonRight ? 'addon-suffix' : '' }}"
        >
          @if (props.addonLeft) {
            <p-inputGroupAddon>
              <span
                [ngStyle]="{
                  cursor: props['addonLeft'].onClick ? 'pointer' : 'inherit',
                }"
                (click)="addonLeftClick($event)"
              >
                @if (props['addonLeft'].icon) {
                  <span [class]="props['addonLeft'].icon"></span>
                }
                @if (props['addonLeft'].text) {
                  <span [innerHTML]="props['addonLeft'].text"></span>
                }
              </span>
            </p-inputGroupAddon>
          }

          @if (props.icon) {
            <p-iconfield>
              @if (props.iconPosition != 'right') {
                <p-inputicon [class]="props.icon" />
              }
              <ng-container #fieldComponent></ng-container>
              @if (props.iconPosition == 'right') {
                <p-inputicon [class]="props.icon" />
              }
            </p-iconfield>
          } @else {
            <ng-container #fieldComponent></ng-container>
          }

          @if (props.addonRight) {
            <p-inputGroupAddon>
              <span
                [ngStyle]="{
                  cursor: props['addonRight'].onClick ? 'pointer' : 'inherit',
                }"
                (click)="addonRightClick($event)"
              >
                @if (props['addonRight'].icon) {
                  <span [class]="props['addonRight'].icon"></span>
                }
                @if (props['addonRight'].text) {
                  <span [innerHTML]="props['addonRight'].text"></span>
                }
              </span>
            </p-inputGroupAddon>
          }
        </p-inputGroup>
      } @else {
        <ng-container #fieldComponent></ng-container>
      }

      @if (props.description) {
        <small
          class="italic ml-[var(--p-inputtext-padding-x)]"
          [innerHTML]="props.description"
        ></small>
      }

      @if (showError) {
        <small
          class="text-[var(--p-form-field-invalid-placeholder-color)] italic ml-[var(--p-inputtext-padding-x)]"
        >
          <formly-validation-message
            class="ui-message-text"
            [field]="field"
          ></formly-validation-message>
        </small>
      } @else if (props.warning) {
        <small
          class="italic text-[var(--p-message-warn-color)] ml-[var(--p-inputtext-padding-x)]"
          [innerHTML]="props.warning"
        ></small>
      }
    </div>
  `,
})
export class FormlyWrapperFormField extends FieldWrapper<
  FormlyFieldConfig<FormlyFieldProps>
> {
  addonRightClick($event: any) {
    if (this.props['addonRight'].onClick) {
      this.props['addonRight'].onClick(this.to, this, $event);
    }
  }

  addonLeftClick($event: any) {
    if (this.props['addonLeft'].onClick) {
      this.props['addonLeft'].onClick(this.to, this, $event);
    }
  }
}
